import * as React from 'react';
import { ListGroup, ListGroupItem, Button } from 'react-bootstrap';
import FailedImagesDropzone from './FailedImagesDropzone';
import { Translate } from '../../../../shared/LanguageService';

interface IFailedOrderRowImagesSectionProps {
    orderRowId: any;
    failedFiles: any[];
    orderId: any;
    onUploadDone: () => void;
    onDelete: (photoUploadMetadataId: number) => void;
}

const FailedOrderRowImagesSection = (props: IFailedOrderRowImagesSectionProps) => {
    return (
        <div>
            <h4>{Translate('image-processing/header/failed-images')}</h4>
            <ListGroup>
                {props.failedFiles.map((x, index) => (
                    <ListGroupItem key={'failed-filenames-' + index}>
                        {x.filename}
                        <Button
                            bsSize="xs"
                            bsStyle="danger"
                            className="pull-right"
                            onClick={() => props.onDelete(x.photoUploadMetadataId)}
                        >
                            <i className="material-icons md-18 no-label">delete</i>
                        </Button>
                    </ListGroupItem>
                ))}
            </ListGroup>
            <FailedImagesDropzone
                orderRowId={props.orderRowId}
                failedFileNames={props.failedFiles.map((x) => x.filename)}
                orderId={props.orderId}
                onUploadDone={props.onUploadDone}
            />
        </div>
    );
};

export default FailedOrderRowImagesSection;
